import * as Sentry from '@sentry/react';
import { isQuotaExceeded } from './quotaSafeStorage';

export function reportClientError(
    error: unknown,
    tags: { surface: string; endpoint?: string },
): void {
    try {
        const err = error instanceof Error ? error : new Error(String(error ?? 'unknown error'));
        // QuotaExceededError is recovered (persist is best-effort; route UI
        // offers "Clear cache and reload"). Sending it to Sentry pages as a
        // high-priority issue — CRYPTO-FRONTEND-F from /workbench.
        if (isQuotaExceeded(error) || isQuotaExceeded(err)) return;
        Sentry.captureException(err, {
            tags: {
                surface: tags.surface,
                endpoint: tags.endpoint || '',
            },
            fingerprint: ['table_load', tags.surface, tags.endpoint || err.name],
        });
    } catch {
        // Sentry must never break the page.
    }
}
